import { useStore } from 'effector-react'
import {
  $totalCountOfLandings,
  landingsListMounted,
  getLandings,
  $landings,
} from './model'
import { LandingRequest } from './types'

export const useLandingsList = () => {
  const onChangeLandingsList = ({ limit, page }: LandingRequest) => {
    landingsListMounted({
      limit,
      page,
    })
  }

  const loading = useStore(getLandings.pending)

  const landings = useStore($landings)
  const totalCountOfLandings = useStore($totalCountOfLandings)

  return { landings, totalCountOfLandings, loading, onChangeLandingsList }
}
